import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { StaffService } from '../staff.service';
import { LeadService } from '../../lead/lead.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';

const states = ["Kingston",
  "St Andrew",
  "St Catherine",
  "Portland",
  "St Mary",
  "St Thomas",
  "Hanover",
  "St Ann",
  "St James",
  "Trelawny",
  "Clarendon",
  "Manchester",
  "St Elizabeth",
  "Westmoreland"]
const cities = ["All", "Chennai", "Dharmapuri", "Krishnagiri", "Hosur", "Dindigul", "Palani", "Erode", "Dharapuram", "Karur", "Kulittalai", "Madurai", "Nagapattinam", "Myladuthurai", "Namakkal", "Nilgiris", "Uppathy", "Coonoor", "Gudalur", "Panthalur", "Udhagamandalam", "Perambalur", "Pudukkottai", "Ramanathapuram", "Salem", "Mettur", "Sivaganga", "Thanjavur", "Theni", "Thoothukudi", "Tiruchiorappalli", "Trichy", "Tirunelveli", "Tenkasi", "Tiruvannamalai", "Arani", "Thiruvarur", "Vellore", "Vaniyambadi", "Tirupattur", "Sholinghur", "Villupuram", "Tirukoilur", "Virudhunagar", "Rajapalayam", "Sivakasi", "Thiruvallur", "Tiruvallur", "Ambathur", "Ariyallur", "Krishnagiri", "Hosur", "Tiruppur", "Coimbatore", "Pollachi", "Anaimalai", "Coimbatore(North)", "Mettupalayam", "Sulur", "Cuddalore", "Chidambaram", "Chidambaram", "Kancheepuram", "Kanniyakumari", "Nagercoil"];
//const regions = ["Zone A", "Zone B", "Zone C", "Zone D"]

@Component({
  selector: 'staff-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CreateComponent implements OnInit {
  public model: any;
  @ViewChild('f') staffCreateForm: NgForm;
  staffType: any = [{
    id: true,
    name: 'Collection Staff Front End'
  }, {
    id: false,
    name: 'Collection Staff Back End'
  }];

  firstName: string;
  lastName: string;
  customId: string;
  primaryMobileNumber: string;
  email: string;
  singlePointReportingManagerId: string;
  remarks: string;
  staff = {
    'firstName': '',
    'lastName': '',
    'email': '',
    'customId': '',
    'primaryMobileNumber': '',
    'yCoreBankingID': '',
    'departmentID': '',
    'designationID': '',
    'collectionStaffBaseBranch': '',
    'singlePointReportingManagerId': '',
    'remarks': ''
  };
  searchAgencies = [];
  isFrontEndStaff: Boolean = false;
  submitted = false;
  departments = []
  designations = []
  armWorkObj = [];
  scpWorkObj = [];
  products = [];
  buckets = [];
  basebranches = [];
  collectionStaffs: any = []
  collectionStaffBaseBranch: string = '';
  agencies = []
  regions = []
  cities = cities
  states = states
  isValid = false
  showOtherRoleWork = false
  showARMWork = false
  singlePointManagerList: any = []
  tempMgr: any = []
  searchText = '';
  role = [];
  armScopeWork = [];
  scopeWork = [];
  public id;
  public product;
  public bucket;
  public region;
  public state;
  public city;
  public departmentId;
  public designationId;
  public managerId;


  constructor(private staffService: StaffService,
    private leadService: LeadService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private router: Router) {
    this.armWorkObj = [];
    this.scpWorkObj = [];

    this.role = [];
    this.armScopeWork = [];
    this.scopeWork = [];
    // this.staffService.fetchStates().subscribe(statesCollection => this.states = statesCollection);
    this.toastr.setRootViewContainerRef(vcr);

    //   this.search = this.staffCreateForm.getControl().valueChanges
    // .debounceTime(200)
    // .switchMap((val:string) =>  val.length > 1
    //     ? this.staffService.getAgencies(val)
    //     : Observable.of([])
    // )
  }
  ngOnInit(): void {
    // deparment list both fornt end and back end staffs
    this.staffService.getDepartmaents().subscribe(
      (departments: any[]) => this.departments = departments,
      (error) => console.log(error)
    );
    // region list both fornt end and back end staffs
    this.leadService.fetchRegions().subscribe(
      (regions: any[]) => this.regions = regions,
      (error) => console.log(error)
    );
    // products for both scp and arm scp

    this.staffService.getProducts().subscribe(
      (products: any[]) => this.products = products,
      (error) => console.log(error)
    );
    // bukckets list both scp and arm
    this.staffService.getBuckets().subscribe(
      (buckets: any[]) => this.buckets = buckets,
      (error) => console.log(error)
    );
    //  get base branches for both front end and back end staff
    this.staffService.getBaseBranches().subscribe(
      (basebranches: any[]) => this.basebranches = basebranches,
      (error) => console.log(error)
    );
    this.getCollectionStaff();
    // this.addARMScope();
    // this.addSCP();

    this.staffService.fetchAgencies()
      .subscribe(agencyListData => {
        this.searchAgencies = [];
        for (var i = 0; i < agencyListData.length; i++) {
          this.searchAgencies.push(agencyListData[i]["firstName"]);
        }
        //this.Agencies = agencyListData;
      });
  }
  // deparment based desingation for nackend staff
  deptBasedDesignaion(data: any): void {
    const departments = { departmentId: [] }
    for (let i = 0; i < data.length; i++) {
      departments.departmentId.push(data[i]['id']);
    }
    this.staffService
      .getDesignations(departments)
      .subscribe(
      (designations: any[]) => this.designations = designations,
      (error) => console.log(error)
      );
  }
  // deparmanet based designation for Scope work section
  deptBasedDesignaionforSCP(data: any, index): void {
    let dep = { departmentId: [] }
    dep.departmentId.push(data.id)
    this.staffService.getDesignations(dep).subscribe(
      (designations: any[]) => this.scpWorkObj[index].designations = designations,
      (error) => console.log(error)
    );
  }

  // region based states for Scope work section
  regionBasedParishforSCP(data: any, index): void {
    this.leadService.fetchStates().subscribe(
      (states: any[]) => {
        this.scpWorkObj[index].states = states;
      },
      (error) => console.log(error)
    );
  }

  // states based Cities for Scope work section
  fetchCities(data: any, index): void {


    if (data.indexOf(':') > -1) {
      data = data.split(':')[1].trim();
    }
    this.leadService.fetchCities().subscribe(
      (cityList: any[]) => {
        this.scpWorkObj[index].cities = cityList;

      },
      (error) => console.log(error)
    );
  }

  //  get single point reporting manager for backend staff
  getCollectionStaff(): void {
    this.armWorkObj = [];
    this.scpWorkObj = [];
    this.staffService.getStaff(this.isFrontEndStaff).subscribe(
      (collectionStaffs: any[]) => this.collectionStaffs = collectionStaffs,
      (error) => console.log(error)
    );
  }
  reportingAgencies(agency, index): void {
    this.staffService.getAgencies(agency).subscribe(
      (agencies: any[]) => this.armWorkObj[index].agencies = agencies,
      (error) => console.log(error)
    );
  }
  //  supervising manager get by name search
  supervisingManager(manager, index): void {
    this.staffService.getCollectionStaffs(manager).subscribe(
      (agencies: any[]) => this.armWorkObj[index].agencies = agencies,
      (error) => console.log(error)
    );
  }
  // add arm scope of work
  addARMScope(): void {
    let armScopeofWork = {
      id: '',
      product: '',
      bucket: '',
      state: '',
      city: '',
      agency: '',
      supervisor: ''
    }
    this.armWorkObj.push(armScopeofWork);
  }
  //  add scope of work
  addSCP(): void {
    let scopeofWork = {
      id: '',
      departmentId: '',
      designationId: '',
      product: '',
      bucket: '',
      region: '',
      state: '',
      city: '',
      supervisor: ''
    }
    console.log(this.scpWorkObj);
    this.scpWorkObj.push(scopeofWork);
  }

  removeSCP(index) {
    this.scpWorkObj.splice(index, 1);
  }
  //  on submit the for create staff

  onSubmit() {
    let staffDetails = {

      'FirstName': this.staff.firstName,
      'LastName': this.staff.lastName,
      'MiddleName': '',
      'PrimaryEMail': this.staff.email,
      'PrimaryMobileNumber': this.staff.primaryMobileNumber,
      'Remarks': this.staff.remarks,
      'EmployeeID': this.staff.customId,
      'Role': '',
      'IsBlackListed': false,
      'BaseBranchId': this.staff.collectionStaffBaseBranch["id"],
      //'singlePointReportingManagerId':this.staff.singlePointReportingManagerId,
      'SinglePointReportingManagerId': this.staff.singlePointReportingManagerId,
      'IsFrontEndStaff': this.isFrontEndStaff,
      'BlackListingReason': '',
      'IsSaveAsDraft': false,
      'userid': '1'

      /*"FirstName": "vamsi",
     "LastName": "reddy",
     "MiddleName": "bogala",
     "PrimaryEMail": "vamsibogala@summerusolutions.com",
     "PrimaryMobileNumber": "8867689100",
     "Remarks": "no ji",
     "Role": "CollectionsStaffBackEnd",
     "IsBlackListed": false,
     "BaseBranchId": "1",
     "SinglePointReportingManagerId": null,
     "IsFrontEndStaff": false,
     "BlackListingReason": "",
     "IsSaveAsDraft": "false",
     "userid": "1",*/
    };

    staffDetails['Roles'] = [];
    for (let p = 0; p < this.staff.departmentID.length; p++) {
      for (let q = 0; q < this.staff.designationID.length; q++) {
        // if (this.staff.departmentID[p]['id'] === this.staff.designationID[q]['departmentId']) {
        console.log(this.staff.designationID)
        staffDetails['Roles'].push({
          'id': null,
          'DepartmentId': this.staff.designationID[p]['departmentId'],
          'DesignationId': this.staff.designationID[q]['id']
        });
        // }
      }
    }

    staffDetails['ScopeOfWork'] = [];
    if (this.scpWorkObj.length > 0) {
      for (let y = 0; y < this.scpWorkObj.length; y++) {        
        staffDetails['ScopeOfWork'].push({
          'Bucket': this.scpWorkObj[y].bucket.id,
          'City': this.scpWorkObj[y].city,
          'Product': this.scpWorkObj[y].product.name,
          'Region': this.scpWorkObj[y].region,
          'State': this.scpWorkObj[y].state,
          'ManagerId': this.scpWorkObj[y]['supervisor']['id'],
          'DepartmentId': this.scpWorkObj[y].departmentId.id,
          'DesignationId': this.scpWorkObj[y].designationId,
          "IsDeleted": false
          //  'managerId':  this.scpWorkObj[y]['supervisor']['id']
        }
        );
      }
    } else {
      staffDetails['ScopeOfWork'].push({
        "Bucket": "",
        "City": "",
        "Product": "",
        "Region": "",
        "State": "",
        "ManagerId": null,
        "DepartmentId": "",
        "DesignationId": "",
        "IsDeleted": false
      }
      );
    }

    console.log(staffDetails);
    this.staffService
      .postStaffDetails(staffDetails)
      .subscribe(
      (collectionStaff: any[]) => {
        var router = this.router;
        setTimeout(function () {
          router.navigateByUrl('/search-staff');
        }, 5000);
        this.toastr.success('User saved successfully.');

      },
      (error) => {
        this.toastr.error('User could not be saved.');
      }
      );

  }

  showSuccess() {
    this.toastr.success('You are awesome.', 'Success.');
  }

  // to remove empty values
  removeEmptyValuesinObject(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    for (var i = 0; i < propNames.length; i++) {
      var propName = propNames[i];
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
  }
  //
  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term => this.staffService.getAgencies(term)
        .catch(() => {
          return Observable.of([]);
        }))

  formatter = (result: { firstName: string }) => result.firstName.toUpperCase();

  showAgencyResult = (result: { firstName: string }) => result.firstName.toUpperCase();

  searchSupervisor = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term => this.staffService.getSupervisor(term)
        .catch(() => {
          return Observable.of([]);
        }))

  formatterSupervisor = (result: { firstName: string }) => result.firstName.toUpperCase();

  supervisorResult = (result: { firstName: string }) => result.firstName.toUpperCase();

  isValidScopeOfWork(): boolean {
    let isValid = true;
    if (this.scpWorkObj != undefined) {
      if (this.scpWorkObj.length > 1) {
        for (var i = 0; i < this.scpWorkObj.length; i++) {
          var temp = this.scpWorkObj[i];
          for (var j = i + 1; j < this.scpWorkObj.length; j++) {
            if (temp.departmentId === this.scpWorkObj[j].departmentId &&
              temp.designationId === this.scpWorkObj[j].designationId &&
              temp.product === this.scpWorkObj[j].product &&
              temp.bucket === this.scpWorkObj[j].bucket &&
              temp.region === this.scpWorkObj[j].region &&
              temp.state === this.scpWorkObj[j].state &&
              temp.city === this.scpWorkObj[j].city &&
              temp.supervisor === this.scpWorkObj[j].supervisor
            ) {

              isValid = false;
              break;
            }
          }
          if (isValid === false) {
            break;
          }
        }
      }
    }
    return isValid;
  }

  isValidARMScopeOfWork(): boolean {
    let isValid = true;
    if (this.armWorkObj.length > 1) {
      for (let i = 0; i < this.armWorkObj.length; i++) {
        const temp = this.armWorkObj[i];
        for (let j = i + 1; j < this.armWorkObj.length; j++) {
          if (temp.product === this.armWorkObj[j].product &&
            temp.bucket === this.armWorkObj[j].bucket &&
            temp.state === this.armWorkObj[j].state &&
            temp.city === this.armWorkObj[j].city &&
            temp.agency === this.armWorkObj[j].agency &&
            temp.supervisor === this.armWorkObj[j].supervisor
          ) {
            isValid = false;
            break;
          }
        }
        if (isValid === false) {
          break;
        }
      }
    }

    return isValid;
  }

  createSinglePointManager(event, index) {
    for (let i = 0; i < this.scpWorkObj.length; i++) {
      let supervisorObj = this.scpWorkObj[i]['supervisor'];
      if (supervisorObj) {
        if (this.collectionStaffs.indexOf(supervisorObj) === -1) {
          this.collectionStaffs.push(supervisorObj);
        }
      }
    }
  }
  // single poiting manager
  getManager(data, type) {

  }

  // fetchCities(state, index) {
  //   var res = state.split(":")[1];
  //   this.staffService
  //     .fetchCities(res.trim())
  //     .subscribe(cities => {
  //       this.scpWorkObj[index]['cities'] = cities;
  //     });
  // }
  cancel() {

  }
}



// WEBPACK FOOTER //
// ./src/app/staff/create/create.component.ts